import { CSSProperties, ReactNode, useEffect, useState } from 'react';
import { COLORS } from '../utils/colors';
import '../styles/components/wrapper.sass';


const Wrapper = ({ children, style, p = 20, mt = 0, mh = 'auto', disabled = false, loading = false, title, subtitle, className, actionComponent }: {
  children?: ReactNode,
  style?: CSSProperties,
  p?: number,
  mt?: number,
  mh?: string | number,
  disabled?: boolean,
  loading?: boolean,
  title?: string,
  subtitle?: string,
  className?: string,
  actionComponent?: ReactNode
}) => {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true); // Trigger fade-in on mount
  }, []);


  let defaultClassNames = `border rounded-lg`;
  if(disabled){
    defaultClassNames += ' bg-slate-100 border-slate-100';
  }
  if(loading){
    defaultClassNames += ' loading';
  }

  return(
    <div className={defaultClassNames + ' '+ className} style={{padding: p, marginTop: mt, ...style}}>
      <div className={'flex justify-between gap-4'}>
        <div>
          {title &&
            <p className={'font-bold text-base'}>{title}</p>
          }
          {subtitle && <p className={'text-slate-400'}>{subtitle}</p>}
        </div>
        {actionComponent}
      </div>
      {(title || subtitle) && <div className={'mb-4'} />}
      {children}
    </div>
  )

};
export default Wrapper;
